import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

export const getMinDateAsToday: NgbDateStruct = {
  year: new Date().getFullYear(),
  month: new Date().getMonth() + 1,
  day: new Date().getDate(),
};

export const getDateFromNgbDate = (ngbDate: NgbDateStruct): Date  => {
  return new Date(ngbDate["year"], ngbDate["month"], ngbDate["day"]);
}

export const getNgbDateFromDate = (date: Date): NgbDateStruct => {
  if(!date){
    return null;
  }

  const dateObject = new Date(date);

  return {
    year: dateObject.getFullYear(),
    month: dateObject.getMonth() + 1,
    day: dateObject.getDate(),
  }
}
